import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface KycInputModel {
    name: string;
    value: string;
    type: 'text' | 'number';
    placeholder: string;
    optional?: boolean;
}

@Component({
    selector: 'app-kyc-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
    @Input() input: KycInputModel;
    @Input() showLabel: boolean;

    @Output() keyUp = new EventEmitter<{}>();

    emitInput(e) {
        this.keyUp.emit({
            name: this.input.value,
            value: e.target.value,
        });
    }

    constructor() {}

    ngOnInit() {}
}
